import React from 'react';

import styled from 'styled-components';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const Paragraph = styled.p`
  font-size: ${({ $textSize = '1rem' }) => $textSize};
  margin-bottom: ${({ $marginBottom = '1rem' }) => $marginBottom};
  font-weight: ${({ $fontWeight = '500' }) => $fontWeight};
  line-height: ${({ $lineHeight = '1.5' }) => $lineHeight};

  @media (max-width: ${breakpoints.mobile}) {
    font-size: ${({ $textMobile = '1rem' }) => $textMobile} !important;
  }
`;

const RichText = ({ dataText, ...props }) => {
  return (
    <>
      {dataText?.map((text, key) => (
        <Paragraph
          as={text.textType}
          key={key}
          $textSize={text.textSize}
          $textMobile={text.textMobile}
          $marginBottom={text.marginBottom}
          $fontWeight={text.fontWeight}
          $lineHeight={text.lineHeight}
          {...props}
        >
          {text.renderContent()}
        </Paragraph>
      ))}
    </>
  );
};

export default RichText;
